/**
 * Store Error Handler
 * Handles creation and formatting of store-related errors
 * Single Responsibility: Error object creation and formatting only
 */

/**
 * Gets default error message based on status code
 * @param {number} status - HTTP status code
 * @returns {string} Error message
 */
function getDefaultErrorMessage(status) {
  const errorMessages = {
    404: "Store not found",
    400: "Invalid request",
    401: "Unauthorized",
    403: "Forbidden",
    500: "Server error",
    503: "Service unavailable"
  };

  return errorMessages[status] || "An error occurred";
}

/**
 * Creates an error object from API response
 * @param {number} status - HTTP status code
 * @param {string} message - Error message
 * @returns {Object} Error object with status, message, and error type flags
 */
export function createStoreError(status, message = "") {
  return {
    status,
    message: message || getDefaultErrorMessage(status),
    isNotFound: status === 404,
    isServerError: status >= 500,
    isClientError: status >= 400 && status < 500
  };
}
